import { render, staticRenderFns } from "./Opto.vue?vue&type=template&id=d74f7bea&scoped=true&"
import script from "./Opto.vue?vue&type=script&lang=js&"
export * from "./Opto.vue?vue&type=script&lang=js&"
import style0 from "./Opto.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Opto.vue?vue&type=style&index=1&id=d74f7bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74f7bea",
  null
  
)

export default component.exports